module.exports = "/packs/003-4db41dbb347af828a5606acb9dcf6a50.jpg";